// import $ from "jquery";
// import 'bootstrap';
// import Swiper from 'swiper/bundle';
import './custom';
// import 'swiper/swiper-bundle.min.css';
import '../sass/main.scss';